import { TiposAlojamientos } from "src/gql/schema"
import Detail from "src/shared/components/data-display/Detail/Detail"
import DetailContent from "src/shared/components/data-display/Detail/kit/DetailContent/DetailContent"
import DetailDivider from "src/shared/components/data-display/Detail/kit/DetailDivider/DetailDivider"
import DetailRow from "src/shared/components/data-display/Detail/kit/DetailRow/DetailRow"
import DetailText from "src/shared/components/data-display/Detail/kit/DetailText/DetailText"
import ResumenSection from "src/shared/components/data-display/Resumen/ResumenSection/ResumenSection"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { getCurrencyFormat } from "src/utils/string"
import { useIVA } from "src/shared/hooks/useIVA"

type DescuentoRow = {
    nombre: string
    monto: number
    tipo_descuento?: string
    valor?: number
}

type Props = {
    roomDays: number
    totalEstancia: number
    totalEstanciaExtra: number
    estanciasExtra: number
    tipoAlojamiento: TiposAlojamientos
    totalCheckInAnticipado?: number
    personasExtra: number
    montoPersonasExtra: number
    roomSerice: number
    numOrdenesRoomService: number
    totalImpuestos: number
    totalPagado: number
    pagosPendientes?: number
    descuentos?: DescuentoRow[]
    horasEstancia?: number
}

const DetailsTotales = ({
    totalEstanciaExtra,
    estanciasExtra,
    roomDays,
    totalEstancia,
    tipoAlojamiento,
    totalCheckInAnticipado,
    personasExtra,
    montoPersonasExtra,
    roomSerice,
    numOrdenesRoomService,
    totalImpuestos,
    totalPagado,
    pagosPendientes,
    descuentos = [],
    horasEstancia,
}: Props) => {
    const { getSubtotal } = useIVA()
    const esMotel = tipoAlojamiento === TiposAlojamientos.Motel
    const nocheONoches = esMotel
        ? horasEstancia ? `(${horasEstancia} horas)` : ""
        : roomDays > 1 ? `(${roomDays} noches)` : `(${roomDays} noche)`

    return (
        <ResumenSection>
            <DetailDivider color='var(--placeholder)' />
            <Detail color='var(--tipografa)'>
                <DetailContent>
                    <DetailRow>
                        <DetailText type='bold'>
                            Estancia {nocheONoches}
                        </DetailText>
                        <DetailText textAlign='right' textWeight={500}>
                            {formatCurrencyToFixed(getSubtotal(totalEstancia))}
                        </DetailText>
                    </DetailRow>
                    {!!totalCheckInAnticipado && (
                        <DetailRow>
                            <DetailText type='bold'>
                                Check-in anticipado
                            </DetailText>
                            <DetailText textAlign='right' textWeight={500} type='normal'>
                                {formatCurrencyToFixed(getSubtotal(totalCheckInAnticipado))}
                            </DetailText>
                        </DetailRow>
                    )}
                    {!!personasExtra && (
                        <DetailRow>
                            <DetailText type='bold'>
                                Personas extra ({personasExtra})
                            </DetailText>
                            <DetailText textAlign='right' textWeight={500} type='normal'>
                                {formatCurrencyToFixed(getSubtotal(montoPersonasExtra))}
                            </DetailText>
                        </DetailRow>
                    )}
                    {!!totalEstanciaExtra && (
                        <DetailRow>
                            <DetailText type='bold'>
                                {esMotel ? "Hospedaje extra" : "Noche extra"} ({estanciasExtra})
                            </DetailText>
                            <DetailText textAlign='right' textWeight={500} type='normal'>
                                {formatCurrencyToFixed(getSubtotal(totalEstanciaExtra))}
                            </DetailText>
                        </DetailRow>
                    )}
                    {!!roomSerice && (
                        <DetailRow>
                            <DetailText type='bold'>
                                Room service ({numOrdenesRoomService})
                            </DetailText>
                            <DetailText textAlign='right' textWeight={500} type='normal'>
                                {formatCurrencyToFixed(getSubtotal(roomSerice))}
                            </DetailText>
                        </DetailRow>
                    )}
                    <DetailRow>
                        <DetailText type='bold' customColor='var(--placeholder)'>
                            Impuestos
                        </DetailText>
                        <DetailText textAlign='right' type='normal' customColor='var(--placeholder)'>
                            {formatCurrencyToFixed(totalImpuestos)}
                        </DetailText>
                    </DetailRow>
                    {descuentos.map((descuento, index) => (
                        <DetailRow key={index}>
                            <DetailText type='bold' style={{ maxWidth: "200px" }}>
                                {descuento.nombre
                                    ? `${descuento.nombre} ${descuento.tipo_descuento === 'porcentaje' ? `-${descuento.valor}%` : `-$${descuento.valor}`}`
                                    : "Descuento"}
                            </DetailText>
                            <DetailText style={{ maxWidth: "75px" }} textAlign='right' textWeight={500} type='normal'>
                                {descuento.monto > 0 ? `-${getCurrencyFormat(descuento.monto)}` : ""}
                            </DetailText>
                        </DetailRow>
                    ))}
                    <DetailRow style={{ marginBottom: "10px" }}>
                        <DetailText textWeight={500} type='normal'>
                            Total pagado
                        </DetailText>
                        <DetailText textAlign="right" textWeight={500} type='normal'>
                            {formatCurrencyToFixed(totalPagado)}
                        </DetailText>
                    </DetailRow>
                    <DetailRow>
                        <DetailText type='bold' textSize={20} textWeight={700}>
                            Total a pagar
                        </DetailText>
                        <DetailText textAlign='right' type='bold' textSize={20} textWeight={700}>
                            {formatCurrencyToFixed(pagosPendientes || 0)}
                        </DetailText>
                    </DetailRow>
                </DetailContent>
            </Detail>
        </ResumenSection>
    )
}

export default DetailsTotales
